import React from 'react';
import Drawer from '@atlaskit/drawer';
import { Content } from './content';
import { Footer } from './footer';
import { Header } from './header';
import { ContentOverride, ContentWrapper, DrawerContainer, DrawerWrapper, ParentContentWrapper, SidebarOverride } from './styled';
const FocusedTask = ({
  testId = 'focused-task',
  currentStep,
  isOpen,
  steps,
  onClose,
  onCloseComplete,
  onOpenComplete,
  headerRightContent,
  rightContent,
  zIndex
}) => {
  const currentStepConfig = steps[currentStep];
  const {
    content,
    isSubmissionLoading,
    isFetchLoading,
    errorContent,
    hasError,
    formId,
    backButtonOnClick,
    nextButtonOnClick,
    type
  } = currentStepConfig;
  const handleDrawerOnClose = () => {
    onClose && onClose();
  };
  const shouldShowHeader = type === 'progress';
  const shouldShowFooter = !hasError && !isFetchLoading && (!!backButtonOnClick || !!nextButtonOnClick || !!formId);
  const contentSize = currentStepConfig.contentSize || 'medium';
  return /*#__PURE__*/React.createElement(Drawer, {
    testId: testId,
    zIndex: zIndex,
    width: "full",
    isOpen: isOpen,
    onClose: () => handleDrawerOnClose(),
    onOpenComplete: onOpenComplete,
    onCloseComplete: onCloseComplete
    // eslint-disable-next-line @atlaskit/design-system/no-deprecated-apis
    ,
    overrides: {
      Sidebar: {
        component: SidebarOverride
      },
      Content: {
        component: ContentOverride
      }
    }
  }, /*#__PURE__*/React.createElement(DrawerContainer, null, /*#__PURE__*/React.createElement(DrawerWrapper, null, /*#__PURE__*/React.createElement(Header, {
    testId: testId,
    steps: steps,
    currentStep: currentStep,
    shouldShowHeader: shouldShowHeader,
    handleDrawerOnClose: handleDrawerOnClose,
    headerRightContent: headerRightContent
  }), /*#__PURE__*/React.createElement(ParentContentWrapper, null, /*#__PURE__*/React.createElement(ContentWrapper, {
    "data-testid": `${testId}-content`,
    contentSize: contentSize
  }, /*#__PURE__*/React.createElement(Content, {
    isFetchLoading: isFetchLoading,
    hasError: hasError,
    isSubmissionLoading: isSubmissionLoading,
    content: content,
    errorContent: errorContent,
    testId: testId
  }))), shouldShowFooter && /*#__PURE__*/React.createElement(Footer, {
    contentSize: contentSize,
    currentStepConfig: currentStepConfig,
    testId: testId,
    currentStep: currentStep
  })), rightContent));
};
export default FocusedTask;